<template>
    <div class="main-width">
        <div class="location_css">
            <img src="../../assets/img/location.png">
            <div>当前位置：</div>
            <div @click="goSy()">首页</div>
            <div> <i class="el-icon-arrow-right"></i> </div>
            <div @click="$router.push('business')">酒企黄页</div>
            <div> <i class="el-icon-arrow-right"></i> </div>
            <div class="location_text">{{result.restaurantName}}</div>
        </div>
        <div v-loading="loading" style="padding: 32px 60px 32px 60px;background-color: #ffffff">
            <div style="border-bottom: 1px dashed #C6C6C6;">
                <div style="color: #333333;font-size: 25px;font-weight: 600;text-align: center;padding-bottom:15px">{{result.restaurantName}}</div>
            </div>
            <div style="padding-top: 27px;color:rgb(153, 153, 153);line-height: 25px;font-size: 14px;" v-html="result.description"></div>
            <!-- <div style="padding-top: 27px;color:rgb(153, 153, 153);line-height: 25px;font-size: 14px;" >{{result.restaurantFeature}}</div> -->
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            loading: false,
            result: {}
        }
    },
    methods: {
        //获取商家简介等信息
        getOasis: function(entityId) {
            var vue = this;
            return new Promise((resolve, reject) => {
                this.$axios.get("oasis/em-entity/detail/" + entityId).then(function(resp) {
                    if (resp.status == 0 || resp.status == "0") {
                        vue.result["description"] = resp.data.description;
                    } else {
                        vue.$message.warning(resp.msg);
                    };
                    vue.loading = false;
                    resolve();
                }, function() {
                    vue.loading = false;
                    resolve();
                    vue.$message.warning("操作失败");
                });
            });

        },
        //返回首页
        goSy:function(){
            this.$router.push({
                path:"/home"
            });
        },
        getNewsDetail: function() {
            let vue = this;
            return new Promise((resolve, reject) => {
                this.$axios.get("/fx-web/wine/restaurant/id?Id="+this.$route.query.id).then(function(resp) {
                    if (resp.errcode == 0 || resp.errcode == "0") {
                        vue.result = resp.data;
                        vue.getOasis(resp.data.entityId).then(()=>{
                            resolve();
                        });
                    } else {
                        vue.$message.warning(resp.msg);
                        resolve();
                    };
                }, function() {
                    vue.$message.error("操作失败");
                    resolve();
                });
            });
        },
    },
    mounted() {
        let vue = this;
        vue.loading = true;
        this.getNewsDetail(vue.$route.query.contentId).then(function(){
            vue.loading = false;
        });
    }
}
</script>